export const PTA_COMPETENCY_ITEMS = [
    // Header
    {
        id: 0,
        type: 'header',
        title: "Clinical Competency Program",
        subtitle: "INITIAL COMPETENCY ASSESSMENT SKILLS CHECKLIST— PHYSICAL THERAPIST ASSISTANT",
        company: "INFINITE HOME HEALTH, INC"
    },

    // Page 1: Administrative/Documentation
    {
        id: 1,
        type: 'section',
        title: "A. Demonstrates ability to process paperwork and associated functions necessary to facilitate:",
        competencies: [
            {
                category: "1. Knowledge of Assessment Process:",
                items: [
                    "a. Assesses response to treatment",
                    "b. Other"
                ]
            },
            {
                category: "2. Documentation Skills: (accurate, legible, timely, and complete)",
                items: [
                    "a. Progress Notes, flow charts",
                    "b. Incident/Variance reporting",
                    "c. Other"
                ]
            },
            {
                category: "3. Adheres to POC",
                items: [
                    "a. Reviews POC prior to care",
                    "b. Performs services as ordered",
                    "c. Documents according to POC",
                    "d. Communicates/coordinates as appropriate",
                    "e. Other"
                ]
            },
            {
                category: "4. Knowledge of Medicare/State Guidelines:",
                items: [
                    "a. Criteria for participation",
                    "b. Skilled reimbursable visit",
                    "c. Other"
                ]
            },
            {
                category: "5. Reports and documents key information to Physician, DC planner, Clinician, Pharmacist, Supervisor"
            },
            {
                category: "6. Participates as team member"
            }
        ]
    },

    // Page 2: Administrative Continued
    {
        id: 2,
        type: 'section',
        title: "A. Demonstrates ability to process paperwork and associated functions necessary to facilitate: (continued)",
        competencies: [
            {
                category: "7. Submits written summary reports as indicated"
            },
            {
                category: "8. Attends/participates in case conference as required"
            },
            {
                category: "9. Supply/HME requisition and management"
            },
            {
                category: "10. Infection Control Practices:",
                items: [
                    "a. Hand washing",
                    "b. Personal protective equipment",
                    "c. Exposure control plan",
                    "d. Equipment care, as appropriate",
                    "e. Other"
                ]
            },
            {
                category: "11. Patient home safety"
            },
            {
                category: "12. Other"
            },
            {
                category: "B. Patient Education:",
                items: [
                    "1. Develops/implement teaching plan",
                    "2. Evaluates effectiveness of teaching",
                    "3. Documents patient response",
                    "4. Other"
                ]
            },
            {
                category: "C. Clinical Skills—General:",
                items: [
                    "1. Vital Signs/I&O",
                    "2. Other"
                ]
            }
        ]
    },

    // Page 3: Skilled Treatments/Interventions
    {
        id: 3,
        type: 'section',
        title: "D. Skilled Treatments/Interventions:",
        competencies: [
            {
                category: "D. Skilled Treatments/Interventions:",
                items: [
                    {
                        text: "1. Perform therapeutic exercises:",
                        subItems: [
                            "a. Active",
                            "b. Passive",
                            "c. Strengthening and endurance",
                            "d. Other"
                        ]
                    },
                    "2. Transfer Activities",
                    {
                        text: "3. Mobilization:",
                        subItems: [
                            "a. Bed mobility",
                            "b. Gait training",
                            "c. Other"
                        ]
                    },
                    {
                        text: "4. Use of Physical agents:",
                        subItems: [
                            "a. Ultrasound",
                            "b. Hot/cold packs",
                            "c. TENS/FES",
                            "d. Massage",
                            "e. Other"
                        ]
                    },
                    {
                        text: "5. Prosthetic Training:",
                        subItems: [
                            "a. Care of prosthesis",
                            "b. Stump conditioning",
                            "c. Other"
                        ]
                    },
                    {
                        text: "6. Assistive Devices:",
                        subItems: [
                            "a. Fit/adjustment",
                            "b. Gait training",
                            "c. Safety",
                            "d. Other"
                        ]
                    },
                    "7. Fabricates orthotic device, instructs in use",
                    "8. Other"
                ]
            }
        ]
    },

    // Page 4: Comments & Signatures
    {
        id: 4,
        type: 'signature',
        title: "Comments & Signatures",
        fields: [
            { label: "Clinician Signature", name: "clinicianSignature" },
            { label: "Date", name: "clinicianDate", inputType: "date" },
            { label: "Supervisor Signature", name: "supervisorSignature" },
            { label: "Date", name: "supervisorDate", inputType: "date" }
        ]
    },

    // Footer
    {
        id: 5,
        type: 'footer',
        text: "Joint Commission Home Health Human Resource/revised October 2012",
        copyright: "© 1995 The Corridor Group, Inc."
    }
];

export const PTA_JOB_DESCRIPTION_ITEMS = [
    // 0: Job Header
    {
        id: 0,
        type: 'header',
        title: "Job Descriptions",
        position: "Physical Therapy Assistant",
        reportsTo: "Physical Therapist or Rehab Supervisor"
    },
    // 1: Job Description Summary
    {
        id: 1,
        type: 'text_block',
        title: "JOB DESCRIPTION SUMMARY:",
        text: "The physical therapy assistant provides physical therapy services under the direction of the physical therapist and according to the physician's plan of care."
    },
    // 2: Essential Job Functions/Responsibilities
    {
        id: 2,
        type: 'section',
        title: "ESSENTIAL JOB FUNCTIONS/RESPONSIBILITIES:",
        duties: [
            "Provides direct physical therapy according to directions of physical therapist and in accordance with the physician's plan of care.",
            "Treats patient to relieve pain, develop or restore function, and maintain maximum performance.",
            "Directs and aids patients in active and passive therapeutic exercises, muscle reeducation, gait and functional training, transfer activities and prosthetic training.",
            "Utilizes physical agents, including, but not be limited to heat, cold, water, light, electricity, ultrasound and massage.",
            "Observes and reports to the physical therapist and the Organization personnel the patient's reaction to treatment and any changes in patient's condition.",
            "Instructs patients in care and use of wheelchairs, braces, crutches, canes, and prosthetic or orthotic devices.",
            "Maintains necessary records; clinical notes and conference notes, which will be incorporated into the patient's clinical record in prescribed time frames.",
            "Participates in Organization Home Care Team Members meetings and Organization Inservice Education Program.",
            "Performs other duties as assigned."
        ]
    },
    // 3: Position Qualifications
    {
        id: 3,
        type: 'section',
        title: "POSITION QUALIFICATIONS:",
        list: [
            "Graduate of an accredited physical therapy assistant program with either an Associate's degree in science or applied science that is approved by American Physical Therapy Association, Inc.",
            "Current certification or license as required by state law.",
            "Possesses and maintains current CPR certification.",
            "Must be a licensed driver with an automobile that is insured in accordance with state or organization requirements and is in good working order."
        ]
    },
    // 4: Signature Block
    {
        id: 4,
        type: 'signature',
        fields: [
            { label: "Employee Signature", name: "employeeSignature" },
            { label: "Date", name: "signatureDate", inputType: "date" }
        ]
    },
    // 5: Footer
    {
        id: 5,
        type: 'footer',
        text: "Joint Commission Home Health Human Resource/revised October 2012",
        copyright: "© 1995 The Corridor Group, Inc."
    }
];
